import { DateTime, Duration } from 'luxon';
import { formatDate } from '../constants/constants';

export const formatJsDate = (date?: Date, format = formatDate): string => {
	if (!date) {
		return '';
	}
	const dateTime = DateTime.fromJSDate(date);
	return dateTime.toFormat(format);
};

export const getJsDate = (date: string, format = formatDate): Date => {
	if (format === 'ISO') {
		return DateTime.fromISO(date).toJSDate();
	}
	const dateTime = DateTime.fromFormat(date, format);
	return dateTime.toJSDate();
};

export const diffDate  = (firstDate: Date,secondDate: Date): Duration => {
	const first = DateTime.fromJSDate(firstDate);
	const second = DateTime.fromJSDate(secondDate);

	return first.diff(second, ["years", "months", "days", "hours"]);
};

export const addMonthToDate = (date: Date, months: number) => {
	return DateTime.fromJSDate(date).plus({ months }).toJSDate();
};